import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Card, Stack, Container, Typography, Tooltip, IconButton, Button } from "@mui/material";
import Page from "../components/Page";
import { Grid } from "@mui/material";
import { fetchAttendance } from "src/utils/common";
import Label from "src/components/Label";
import { CSVLink } from "react-csv";

export default function Attendace() {
  const location = useLocation();
  const navigate = useNavigate();
  const [presentlist, setpresentlist] = useState([]);
  const [absentlist, setabsentlist] = useState([]);
  const [visitorlist, setvisitorlist] = useState([]);
  const [meetingClosedate, setMeetingCloseDate] = useState([]);
  let { m_id } = useParams();
  // useEffect(async () => {
  //   const resp = await fetchAttendance(m_id);
  //   setMeetingCloseDate(resp.data.meeting_close_date);
  //   setpresentlist(resp.data.presentList);
  //   setabsentlist(resp.data.absentList);
  //   console.log()
  //   setvisitorlist(
  //     location?.state?.status === 0
  //       ? location?.state?.PendingMeetingVisitorList
  //       : resp.data.visitorList
  //   );
  // }, []);

  useEffect(() => {
    const getAttendanceData = async () => {
      // 🛑 If status === 0 → DO NOT call API
      if (location?.state?.status === 0) {
        console.log("Using passed visitor list, API not called");

        setvisitorlist(location?.state?.PendingMeetingVisitorList || []);
        return;
      }

      // ✅ Otherwise call API
      const resp = await fetchAttendance(m_id);

      setMeetingCloseDate(resp.data.meeting_close_date);
      setpresentlist(resp.data.presentList);
      setabsentlist(resp.data.absentList);
      setvisitorlist(resp.data.visitorList);
    };

    getAttendanceData();
  }, [m_id, location.state]);

  const presentDirectors = (presentlist || []).filter((k) => k.is_director == 1);
  const presentMembersOnly = (presentlist || []).filter((k) => k.is_director != 1);
  const absentDirectors = (absentlist || []).filter((k) => k.is_director == 1);
  const absentMembersOnly = (absentlist || []).filter((k) => k.is_director != 1);

  const expo_columns = [
    { label: "No.", key: "id" },
    { label: "Visitor Name", key: "m_name" },
    { label: "Visitor Mobile No.", key: "mo_no" },
    { label: "Visitor Business Name", key: "business_name" },
    { label: "Invited By Member Name", key: "visitor_invited_by" },
    { label: "Chapter Status", key: "visitor_in_chapter_type" },
    { label: "Other Chapter Name", key: "other_chapter_name" },
    { label: "Visitor Added Date", key: "visit_date" }
  ];

  return (
    <Page title="Attendance | Local Vocal Business Group">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h4" gutterBottom>
            {location.state.status === 0 ? "Visitor List" : "Attendance"}
          </Typography>
        </Stack>

        {location.state?.status === -1 ? (
          <>
            <div style={{ marginBottom: "20px" }}>
              <h4>Meeting Date: {location.state?.date}</h4>
              <h4>Meeting Close Date: {meetingClosedate}</h4>
              <h4> Meeting End By: {location.state?.name}</h4>
            </div>
          </>
        ) : (
          <>
            <div style={{ marginBottom: "20px" }}>
              <h4>Chapter Name: {location.state?.chapter}</h4>
              <h4>Meeting Date: {location.state?.date}</h4>
            </div>
          </>
        )}

        <Button
          variant="contained"
          onClick={() => {
            navigate("/meeting", {
              state: {
                filter: location.state?.filter,
                tab: location.state?.tab,
                currentPage: location.state?.currentPage
              }
            });
          }}
        >
          Back
        </Button>

        {location.state?.status === 0 ? (
          <Button className="btn btn-export">
            <CSVLink
              data={visitorlist?.map((vis, index) => {
                return {
                  id: index + 1,
                  ...vis
                };
              })}
              headers={expo_columns}
              filename={`${location.state.chapter} - (${location.state.date}).csv`}
              className="btn btn-primary test"
              target="_blank"
            >
              Export CSV
            </CSVLink>
          </Button>
        ) : (
          ""
        )}
        <Grid container spacing={2}>
          {location.state?.status === -1 ? (
            <>
              {" "}
              <Grid item xs={4}>
                <Card
                  style={{
                    marginBottom: "25px",
                    marginTop: "25px"
                  }}
                >
                  <div
                    style={{
                      padding: "25px",
                      background: "#1c4766",
                      display: "flex",
                      justifyContent: "space-between"
                    }}
                  >
                    <label
                      style={{
                        marginBottom: "0",
                        fontWeight: "bold",
                        color: "white",
                        fontSize: "20pVisitorx"
                      }}
                    >
                      Present Members
                    </label>
                    <label
                      style={{
                        marginBottom: "0",
                        fontWeight: "bold",
                        color: "white",
                        fontSize: "20px"
                      }}
                    >
                      {presentlist != [] ? presentlist.length : 0}
                    </label>
                  </div>

                  {presentDirectors.length > 0 && (
                    <>
                      <h4
                        style={{
                          padding: "5px 25px",
                          margin: 0,
                          background: "#eff5fb",
                          color: "#1c4766",
                          fontSize: "12px",
                          fontWeight: 700,
                          textTransform: "uppercase",
                          letterSpacing: "0.6px"
                        }}
                      >
                        Chapter Director
                      </h4>
                      {presentDirectors.map((k) => (
                        <h4
                          key={`pd-${k.m_id}`}
                          style={{
                            padding: "5px 25px",
                            borderBottom: "1px solid #e5e8eb"
                          }}
                        >
                          {k.m_name}
                        </h4>
                      ))}
                    </>
                  )}
                  {presentMembersOnly.length > 0 && presentDirectors.length > 0 && (
                    <div
                      style={{
                        background: "#f5f5f5",
                        margin: 0
                      }}
                    >
                      <h4
                        style={{
                          padding: "6px 25px",
                          margin: 0,
                          color: "#555",
                          fontSize: "12px",
                          fontWeight: 700,
                          textTransform: "uppercase",
                          letterSpacing: "0.6px"
                        }}
                      >
                        Members
                      </h4>
                    </div>
                  )}
                  {presentMembersOnly &&
                    presentMembersOnly.map((k) => {
                      return (
                        <>
                          <h4
                            key={`pm-${k.m_id}`}
                            style={{
                              padding: "5px 25px",
                              borderBottom: "1px solid #e5e8eb"
                            }}
                          >
                            {k.m_name}
                          </h4>
                        </>
                      );
                    })}
                </Card>
              </Grid>
              <Grid item xs={4}>
                <Card
                  style={{
                    marginBottom: "25px",
                    marginTop: "25px"
                  }}
                >
                  <div
                    style={{
                      padding: "25px",
                      background: "#1c4766",
                      display: "flex",
                      justifyContent: "space-between"
                    }}
                  >
                    <label
                      style={{
                        marginBottom: "0",
                        fontWeight: "bold",
                        color: "white",
                        fontSize: "20px"
                      }}
                    >
                      Absent Members
                    </label>
                    <label
                      style={{
                        marginBottom: "0",
                        fontWeight: "bold",
                        color: "white",
                        fontSize: "20px"
                      }}
                    >
                      {absentlist != [] ? absentlist.length : 0}
                    </label>
                  </div>

                  {absentDirectors.length > 0 && (
                    <>
                      <h4
                        style={{
                          padding: "6px 25px",
                          margin: 0,
                          background: "#eff5fb",
                          color: "#1c4766",
                          fontSize: "12px",
                          fontWeight: 700,
                          textTransform: "uppercase",
                          letterSpacing: "0.6px"
                        }}
                      >
                        Chapter Director
                      </h4>
                      {absentDirectors.map((k) => (
                        <h4
                          key={`ad-${k.m_id}`}
                          style={{
                            padding: "5px 25px",
                            borderBottom: "1px solid #e5e8eb"
                          }}
                        >
                          {k.m_name}
                        </h4>
                      ))}
                    </>
                  )}
                  {absentMembersOnly.length > 0 && absentDirectors.length > 0 && (
                    <div
                      style={{
                        background: "#f5f5f5",
                        margin: 0
                      }}
                    >
                      <h4
                        style={{
                          padding: "6px 25px",
                          margin: 0,
                          color: "#555",
                          fontSize: "12px",
                          fontWeight: 700,
                          textTransform: "uppercase",
                          letterSpacing: "0.6px"
                        }}
                      >
                        Members
                      </h4>
                    </div>
                  )}
                  {absentMembersOnly &&
                    absentMembersOnly.map((k) => {
                      return (
                        <>
                          <h4
                            key={`am-${k.m_id}`}
                            style={{
                              padding: "5px 25px",
                              borderBottom: "1px solid #e5e8eb"
                            }}
                          >
                            {k.m_name}
                          </h4>
                        </>
                      );
                    })}
                </Card>
              </Grid>
            </>
          ) : null}
          <Grid item xs={location.state?.status === -1 ? 4 : 12}>
            <Card
              style={{
                marginBottom: "25px",
                marginTop: "25px"
              }}
            >
              <div
                style={{
                  padding: "25px",
                  background: "#1c4766",
                  display: "flex",
                  justifyContent: "space-between"
                }}
              >
                <label
                  style={{
                    marginBottom: "0",
                    fontWeight: "bold",
                    color: "white",
                    fontSize: "20px"
                  }}
                >
                  Visitor
                </label>
                <label
                  style={{
                    marginBottom: "0",
                    fontWeight: "bold",
                    color: "white",
                    fontSize: "20px"
                  }}
                >
                  {visitorlist != [] ? visitorlist.length : 0}
                </label>
              </div>

              {visitorlist &&
                visitorlist?.map((k) => {
                  return (
                    <div
                      style={{
                        padding: "5px 25px",
                        borderBottom: "5px solid #e5e8eb"
                      }}
                    >
                      <h4>
                        Visitor Name : <span style={{ fontWeight: "normal" }}>{k.m_name}</span>
                      </h4>
                      {location.state.status === 0 ? (
                        <>
                          <h4>
                            Visitor Mobile No. :{" "}
                            <span style={{ fontWeight: "normal" }}>{k.mo_no}</span>
                          </h4>
                          <h4>
                            Visitor Business Name. :{" "}
                            <span style={{ fontWeight: "normal" }}>{k.business_name}</span>
                          </h4>
                        </>
                      ) : null}
                      <h4>
                        Invited By :{" "}
                        <span style={{ fontWeight: "normal" }}>{k.visitor_invited_by}</span>
                      </h4>
                      <h4>Type : {k.visitor_in_chapter_type}</h4>
                      {location.state.status === 0 ? (
                        <>
                          {" "}
                          <h4>
                            Chapter Name :{" "}
                            <span style={{ fontWeight: "normal" }}>{k.other_chapter_name}</span>
                          </h4>
                          <h4>
                            Visitor Added Date :{" "}
                            <span style={{ fontWeight: "normal" }}>{k.visit_date}</span>
                          </h4>{" "}
                        </>
                      ) : null}
                    </div>
                  );
                })}
            </Card>
          </Grid>
        </Grid>

        {/* End Category Form */}
      </Container>
    </Page>
  );
}
